import SchemaValidator from "../../../schema-validator";
import { Type } from "@sinclair/typebox";

const logStartRecording = new SchemaValidator(Type.String());

export default {
	logStartRecording,
};
